module.exports = __webpack_public_path__ + "static/img/NihonSkin_logo.c243093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/NihonSkin_logo.png
// module id = yhmJ
// module chunks = 0